import AccessLogAPI from '@/api/AccessLogAPI.js';
import httpClient from '@/api/axios-httpclient';
export default {
	getAccessLogs: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: AccessLogAPI.getAPIUrl() + '/paging',
				data: payload
			},
			true
		);

		if (res.Success) {
			context.commit('updateAccessLogData', res.Data);
			context.commit('updateCondition', payload);
			context.commit('updateQuickSearchText', payload.Text);
		}

		// Trả kết quả
		return res;
	},

	updateCacheCondition(context, param) {
		if (param) {
			context.commit('updateCondition', param);
		}
	}
};
